
import axios from 'axios';
import { useState, useEffect } from 'react';
import { Get_Setting, Set_Setting } from '../../../../api/api';
import Loading from './../../../Loading';
import { toast } from 'react-toastify';

const separate = (Number) => {
     Number += '';
     Number = Number.replace(',', '');
     let x = Number.split('.');
     let y = x[0];
     let z = x.length > 1 ? '.' + x[1] : '';
     var rgx = /(\d+)(\d{3})/;
     while (rgx.test(y))
          y = y.replace(rgx, '$1' + ',' + '$2');
     return y + z;
}

const GetSetting = () => {

     const [isLoading, setIsLoading] = useState(false)
     const [isLoadingForm, setIsLoadingForm] = useState(false)
     const [toman, setToman] = useState(0)

     const handleSubmitForm = async (e) => {
          e.preventDefault()
          let price = parseInt(e.target.requestToman.value)
          if (price !== toman) {
               try {
                    setIsLoadingForm(true)
                    await axios.post(Set_Setting, {
                         "minimumSettlement": price
                    })
                    setToman(price)
                    toast.success('قیمت بروزرسانی شد!')
               } finally { setIsLoadingForm(false) }
          }
     }

     const handleChangeInput = (e) => {
          setToman(e.target.value !== '' ? e.target.value : 0)
     }


     useEffect(() => {
          const GET_settings = async () => {
               try {
                    setIsLoading(true)
                    const res = await axios.get(Get_Setting)
                    setToman(res?.data.minimumSettlement)
               } finally { setIsLoading(false) }
          }
          GET_settings()
     }, [])

     return (
          <div className="contentHolder pt-0">
               <div className="row">
                    <div className="col-12">
                         <div className="box_radios">

                              <div className="headHolder bordered"><p className="title">حداقل میزان پول قابل برداشت</p></div>

                              <div className="requestSettingForm" style={{ padding: '20px' }}>
                                   {isLoading ? <Loading styles={'mini'} /> : (

                                        <form onSubmit={handleSubmitForm}>
                                             <p> <input type="number" defaultValue={toman ? toman : 0} onChange={handleChangeInput} name='requestToman' placeholder='مبلغ را به تومان وارد نمایید' />
                                                  <span style={{ fontWeight: 300, fontSize: '14px' }}>حداقل مبلغ قابل برداشت <small style={{ fontSize: '16px', fontWeight: 'normal' }}>{separate(toman)}</small> تومان است.</span>
                                             </p>
                                             <br />
                                             {isLoadingForm
                                                  ?
                                                  <p><button type="button" className='disabled' style={{ padding: '1rem 2rem' }}> لطفا صبر کنید...</button></p>
                                                  :
                                                  <p><input type="submit" value="ذخیره" /></p>
                                             }
                                        </form>

                                   )}

                              </div>

                         </div>
                    </div>
               </div>
          </div>
     )
}

export default GetSetting